import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../../../../utils/dateUtils';

/**
 * AssignmentSelectionCard - Eine für Performance optimierte Karte zur Auswahl eines Einsatzes.
 * Nutzt React.memo, um unnötige Rerenders in langen Listen zu verhindern.
 */
const AssignmentSelectionCard = memo(({ 
    assignment, 
    isSelected, 
    onToggle, 
    onClick, 
    onHover, 
    onHoverEnd,
    style 
}) => {
    return (
        <div 
            className={`details-selection-card ${isSelected ? 'selected' : ''} status-${assignment.status}`} 
            onClick={() => onToggle(assignment.id)} 
            onMouseEnter={(e) => onHover?.(assignment, e)} 
            onMouseLeave={onHoverEnd}
            style={style}
        >
            <div className={`custom-checkbox mini ${isSelected ? 'checked' : ''}`}>
                {isSelected ? '✓' : ''}
            </div>
            <div className="details-card-info">
                <span className="details-card-title">{assignment.project_name}</span>
                <span className="details-card-meta">
                    {assignment.start_datetime ? formatDate(assignment.start_datetime.replace(' ', 'T')) : 'Undatiert'} · {assignment.location || 'Kein Ort'}
                </span>
            </div>
            <button 
                className="details-info-btn" 
                onClick={(e) => { e.stopPropagation(); onClick?.(assignment); }}
            >
                ⓘ
            </button>
        </div>
    );
});

AssignmentSelectionCard.displayName = 'AssignmentSelectionCard';

AssignmentSelectionCard.propTypes = {
    assignment: PropTypes.object.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    onClick: PropTypes.func,
    onHover: PropTypes.func,
    onHoverEnd: PropTypes.func,
    style: PropTypes.object
};

export default AssignmentSelectionCard;
